import { Trans } from '@lingui/macro'
import HYDRA_CHAIN_ABI from 'abis/governance/HydraChain.json'
import { useHydraChainContract } from 'hooks/useGovernanceContracts'

import ContractWidget from '../components/ContractWidget'
import { SectionTitle } from '../styleds'

export default function HydraChainTab() {
  const contract = useHydraChainContract()

  return (
    <>
      <SectionTitle>
        <Trans>HydraChain Contract (0x...0101)</Trans>
      </SectionTitle>

      <ContractWidget
        title="HydraChain"
        description="Main chain contract handling validators, whitelisting, bans, epochs, and governance. Coordinates ValidatorManager, Inspector, and Whitelisting modules."
        contract={contract}
        abi={HYDRA_CHAIN_ABI as any}
        defaultFunction="getValidators"
      />
    </>
  )
}
